export const PLATFORM_LABEL: Record<number, string> = {
    0: 'Instagram',
    1: 'Facebook',
    2: 'Telegram',
    3: 'YouTube',
    4: 'X',
    5: 'WhatsApp',
    6: 'LinkedIn',
    7: 'Viber',
};
